import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Loader from "../../components/common/Loader";
import Footer from "../../components/home1/Footer";
import Menu from "../../components/innerpage/Menu";
import Navbar from "../../components/home1/Navbar";
import { useBlogs } from "../../common/BlogContext";
import { SITE_NAME } from "../../seoConfig";

function BlogPost() {
  const { id } = useParams();
  const { blogs } = useBlogs();

  const blog = blogs.find((b) => String(b.id) === String(id));
  const others = blogs.filter((b) => String(b.id) !== String(id));

  if (!blog) {
    return (
      <>
        <Helmet>
          <link rel="stylesheet" type="text/css" href="/innerpages/assets/css/innerpages.css" />
          <link rel="stylesheet" type="text/css" href="/innerpages/assets/css/navbar-fix.css" />
        </Helmet>
        <body className="inner-pages-style1 post-pg-style1">
          <Loader />
          <Menu />
          <div className="smooth-scroll-content" id="scrollsmoother-container">
            <Navbar />
            <main>
              <div style={{ textAlign: "center", padding: "120px 24px" }}>
                <h2 className="fsz-45 mb-30">Article not found</h2>
                <Link to="/blog" className="butn border rounded-pill color-orange1 border-orange1 hover-bg-orange1 px-5">
                  <span>← Back to Blog</span>
                </Link>
              </div>
            </main>
            <Footer />
          </div>
        </body>
      </>
    );
  }

  const tags = blog.category
    ? blog.category.split(/[,\s]+/).filter(Boolean)
    : [];

  const plainBody = (blog.body || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  const metaDescription = plainBody.length > 160 ? `${plainBody.slice(0, 157)}...` : plainBody;

  return (
    <>
      <Helmet>
        <title>{`${blog.title} | ${SITE_NAME}`}</title>
        {metaDescription && <meta name="description" content={metaDescription} />}
        <link rel="stylesheet" type="text/css" href="/innerpages/assets/css/innerpages.css" />
        <link rel="stylesheet" type="text/css" href="/innerpages/assets/css/navbar-fix.css" />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>

      <body className="inner-pages-style1 post-pg-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />

          <main>

            {/* ── Hero — same as single_post/Slider.jsx ── */}
            <section className="tc-main-img-style1 header">
              <div className="main-img">
                {blog.img ? (
                  <img
                    src={blog.img}
                    alt={blog.title}
                    className="img-cover"
                    data-speed="1.25"
                  />
                ) : (
                  <div style={{ background: "#1a1a2e", width: "100%", height: "100%", position: "absolute", inset: 0 }} />
                )}
              </div>
              <div className="content">
                <div className="container">
                  <div className="info">
                    <div className="date fsz-12 text-uppercase mb-30">
                      {tags[0] && <a href="#"> {tags[0]} </a>}
                      {tags[0] && blog.publish_date && (
                        <span className="circle icon-3 bg-white rounded-circle mx-3"></span>
                      )}
                      {blog.publish_date && <a href="#"> {blog.publish_date} </a>}
                    </div>
                    <h2 className="title">
                      <span className="hover-orange1">{blog.title}</span>
                    </h2>
                  </div>
                </div>
              </div>
            </section>

            {/* ── Content — same as single_post/Content.jsx ── */}
            <section className="tc-post-content-style1">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-8">
                    <div className="info">

                      {/* Breadcrumb */}
                      <div className="breadcromb wow fadeInUp slow" data-wow-delay="0.2s">
                        <Link to="/"> Home </Link>
                        <span className="icon">/</span>
                        <Link to="/innerpages/blog"> Blog </Link>
                        <span className="icon">/</span>
                        <a href="#"> {blog.title} </a>
                      </div>

                      {/* Title as intro heading */}
                      <h6 className="fsz-24 fw-600 mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
                        {blog.title}
                      </h6>

                      {/* Body content */}
                      {blog.body ? (
                        <div
                          className="text fsz-14 color-666 mb-70 wow fadeInUp slow"
                          data-wow-delay="0.2s"
                          style={{ lineHeight: "2", whiteSpace: "pre-wrap" }}
                        >
                          {blog.body}
                        </div>
                      ) : (
                        <div className="text fsz-14 color-666 mb-70 wow fadeInUp slow" data-wow-delay="0.2s">
                          <p style={{ fontStyle: "italic", color: "#aaa" }}>
                            No content added yet.{" "}
                            <Link to="/admin" style={{ color: "#c69b3a" }}>
                              Edit this article in Admin →
                            </Link>
                          </p>
                        </div>
                      )}

                      {/* Tags + Share */}
                      <div className="share-content wow fadeInUp slow" data-wow-delay="0.2s">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <div className="tags">
                              {tags.map((tag, i) => (
                                <a key={i} href="#"> {tag} </a>
                              ))}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="share mt-4 mt-lg-0 justify-content-lg-end">
                              <span className="txt me-3"> Share on </span>
                              <div className="links">
                                <a href="#"><i className="fab fa-x-twitter"></i></a>
                                <a href="#"><i className="fab fa-facebook-f"></i></a>
                                <a href="#"><i className="fab fa-blogger"></i></a>
                                <a href="#"><i className="fab fa-discord"></i></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ── Latest Articles — same as related-posts in Content.jsx ── */}
                      {others.length > 0 && (
                        <div className="related-posts">
                          <div className="title mb-70">
                            <div className="row align-items-center wow fadeInUp slow" data-wow-delay="0.2s">
                              <div className="col-lg-8">
                                <h3 className="fsz-45 text-capitalize"> Latest Articles </h3>
                              </div>
                              <div className="col-lg-4 mt-4 mt-lg-0">
                                <div className="arrows me-lg-0 ms-lg-auto">
                                  <div className="swiper-button-prev"></div>
                                  <div className="swiper-button-next"></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="related-slider wow fadeInUp slow" data-wow-delay="0.2s">
                            <div className="swiper-wrapper">
                              {others.slice(0, 6).map((item) => {
                                const itemTags = item.category
                                  ? item.category.split(/[,\s]+/).filter(Boolean)
                                  : [];
                                return (
                                  <div key={item.id} className="swiper-slide">
                                    <div className="post-card">
                                      <Link
                                        to={`/blog/${item.id}`}
                                        className="img th-280 radius-7 overflow-hidden d-block"
                                      >
                                        {item.img ? (
                                          <img src={item.img} alt={item.title} className="img-cover" />
                                        ) : (
                                          <div
                                            style={{
                                              background: "#f0f0ff",
                                              height: "100%",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              color: "#c4b5fd",
                                              fontSize: 36,
                                            }}
                                          >
                                            <i className="ti ti-photo" aria-hidden="true"></i>
                                          </div>
                                        )}
                                      </Link>
                                      <div className="info pt-30">
                                        <div className="tags color-666 text-uppercase fsz-12">
                                          <a href="#" className="color-orange1">
                                            {itemTags.join(", ")}
                                          </a>
                                          {item.publish_date && (
                                            <>
                                              <span className="circle icon-3 bg-666 rounded-circle mx-3"></span>
                                              <a href="#"> {item.publish_date} </a>
                                            </>
                                          )}
                                        </div>
                                        <h3 className="title mt-15">
                                          <Link to={`/blog/${item.id}`} className="hover-orange1 fsz-24">
                                            {item.title}
                                          </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </section>

          </main>

          <Footer />
        </div>
      </body>
    </>
  );
}

export default BlogPost;